import { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router'
import {
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Button,
  Form,
  FormGroup,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap'
import { SEARCH_TYPES } from '~/lib/constants/search'

function SearchModal ({ title, searchModalOpen, toggleSearchModal }) {
  const [search, setSearch] = useState('')
  const handleSetSearch = useCallback(event => setSearch(event.target.value), [])
  const [searchCurrent, setSearchCurrent] = useState(false)
  const handleSetSearchMode = useCallback(event => setSearchCurrent(event.currentTarget.id === 'current'), [])
  let mobileSearchForm = null

  // Handle new search
  const handleSearch = useCallback(() => {
    const searchTrimmed = search.trim()
    const searchType = Object.keys(SEARCH_TYPES).find(key => SEARCH_TYPES[key] === title)

    const query = { q: searchTrimmed, searchType: searchCurrent && searchType && searchType.length > 0 ? searchType : null }

    if (searchTrimmed.length > 0) {
      Router.push({ pathname: '/search', query }, { pathname: '/search', query })
        .then(() => window.scrollTo(0, 0))

      toggleSearchModal()
    }

    setSearch('')
    setSearchCurrent(false)
  }, [title, search, searchCurrent])

  // Handle pressing enter
  const handleKeyPress = useCallback((event) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }, [title, search, searchCurrent])

  // Include current vs all if applicable
  if (Object.values(SEARCH_TYPES).includes(title)) {
    const currentLabelText = `${title} only`

    mobileSearchForm = (
      <Form className='pt-4 d-md-none'>
        <FormGroup>
          <CustomInput
            className='py-1'
            type='radio'
            id='all'
            label='All pages'
            name='mobileSearch'
            onChange={handleSetSearchMode}
            defaultChecked
          />
          <CustomInput
            className='py-1'
            type='radio'
            id='current'
            label={currentLabelText}
            name='mobileSearch'
            onChange={handleSetSearchMode}
          />
        </FormGroup>
      </Form>
    )
  }

  return (
    <Modal
      isOpen={searchModalOpen}
      toggle={toggleSearchModal}
      modalTransition={{ timeout: 0 }}
      backdropTransition={{ timeout: 0 }}
      autoFocus={false}
      size='lg'
    >
      <ModalHeader tag='h2' close={<i className='close fa fa-close cursor-pointer' onClick={toggleSearchModal} />}>
        Search for things like resources, FAQ, or news
      </ModalHeader>
      <ModalBody>
        <InputGroup>
          <InputGroupAddon addonType='prepend'>
            <InputGroupText className='bg-white'>
              <i className='fa fa-search fa-lg' />
            </InputGroupText>
          </InputGroupAddon>
          <Input
            className='border-left-0'
            value={search}
            placeholder='Search'
            maxLength='50'
            autoFocus
            onChange={handleSetSearch}
            onKeyPress={handleKeyPress}
          />
        </InputGroup>
        {mobileSearchForm}
        <Row className='mt-4 text-right'>
          <Col>
            <Button color='primary' size='lg' onClick={handleSearch}>Search Now</Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

SearchModal.propTypes = {
  title: PropTypes.string,
  searchModalOpen: PropTypes.bool.isRequired,
  toggleSearchModal: PropTypes.func.isRequired
}

export default SearchModal
